
import { AfterContentInit, Directive, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";
import { ToggleFieldGroupComponent } from "../field-toggle-group.component";
import { FieldToggleManager } from "../toggle-manager.service";

@Directive({
    selector: "common-field-toggle-group[disabled-fields-strategy]",
    providers: [FieldToggleManager],
})
export class DisabledFieldsStrategyDirective implements OnDestroy, AfterContentInit {
    private state$: Subscription;
    private toggleState$: Subscription[];

    constructor(
        private hostRef: ToggleFieldGroupComponent,
        private toggleManager: FieldToggleManager,
    ) { }

    public ngAfterContentInit(): void {
        this.state$ = this.toggleManager.state$.pipe(
            distinctUntilChanged(this.toggleManager.distinctUntilChangedFactory(this.allFieldProps)))
            .subscribe((state) => {
                this.setToggleFieldsDisabledState();
                this.setToggleControlsDisabledState();
            });

        this.toggleState$ = this.hostRef.toggleControls
            .map((toggleControl) => toggleControl.toggleState$.subscribe((toggleState) => {
                this.hostRef.toggleFields.forEach((field) => field.isDisabled = toggleState);
            }));
    }

    public ngOnDestroy(): void {
        this.state$.unsubscribe();
        this.toggleState$.forEach((toggleState$) => toggleState$.unsubscribe());
    }

    public setToggleFieldsDisabledState(): void {
        const shouldDisableFields = this.dataIsEmpty && this.atLeastOneControlToggled;
        if (shouldDisableFields) { this.hostRef.toggleFields.forEach((field) => field.isDisabled = true); }
    }

    public setToggleControlsDisabledState(): void {
        this.hostRef.toggleControls.forEach((toggleControl) => toggleControl.disableToggle = !this.dataIsEmpty);
    }

    public get allFieldProps(): string[] {
        return this.toggleManager.allToggleFieldProps;
    }

    public get dataIsEmpty(): boolean {
        return this.toggleManager.allFieldsAreEmpty(this.allFieldProps);
    }

    public get atLeastOneControlToggled(): boolean {
        return this.hostRef.toggleControls.some((toggleControl) => toggleControl.toggleState);
    }
}
